<table class="table" mat-table [dataSource]="tableDataSource" matSort>
  <ng-container matColumnDef="logoUrl">
    <th mat-header-cell *matHeaderCellDef>Logo</th>
    <td mat-cell *matCellDef="let element">
      <img
        [src]="element.logoUrl"
        [alt]="element.name + ' logo'"
        class="partner-logo"
        *ngIf="element.logoUrl"
      />
      <span *ngIf="!element.logoUrl">No logo</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
    <td mat-cell *matCellDef="let element">{{ element.name }}</td>
  </ng-container>

  <ng-container matColumnDef="redirectUrl">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Redirect URL</th>
    <td mat-cell *matCellDef="let element">{{ element.redirectUrl }}</td>
  </ng-container>

  <ng-container matColumnDef="billingCycle">
    <th mat-header-cell *matHeaderCellDef>Billing Cycle</th>
    <td mat-cell *matCellDef="let element">{{ getBillingCycleLabel(element.partnerId) }}</td>
  </ng-container>

  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <button
        mat-icon-button
        color="primary"
        (click)="openBillingCycleModal(element)"
        aria-label="Edit Billing Cycle"
      >
        <mat-icon>edit</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
  <tr class="listitem" mat-row *matRowDef="let row; columns: columnNames"></tr>
</table>
